<template>
  <div class="content">
    <div class="row">
      <div
        class="col-lg-3 col-md-6"
        v-for="(card, i) in statsCards"
        :key="i"
      >
        <stats-card
          :title="card.title"
          :sub-title="card.subTitle"
          :type="card.type"
          :icon="card.icon"
        >
          <div slot="footer" class="text-center">
            <base-button link @click="filterPatent(card.statusCode)">
              Detil
            </base-button>
          </div>
        </stats-card>
      </div>
    </div>
    <card card-body-classes="table-full-width" header-classes="mb-0">
      <div class="row mb-3 px-2">
        <div class="col-8">
          <patent-search :isWithPCTID="true" @handle-data="handleData"/>
        </div>
      </div>
      <el-table :data="queriedData" ref="table">
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          :min-width="column.minWidth"
          :prop="column.prop"
          :label="column.label"
        >
        </el-table-column>
        <el-table-column :min-width="135" align="right" label="Actions">
          <div slot-scope="props">
            <el-tooltip
              class="item"
              effect="dark"
              content="Detail"
              placement="top"
            >
              <base-button
                @click.native="goToDetail(props.row)"
                class="edit btn-link"
                type="warning"
                size="sm"
                icon
              >
                <i class="el-icon-edit"></i>
              </base-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="Workflow"
              placement="top"
            >
              <base-button
                @click.native="goToWorkflow(props.row)"
                class="edit btn-link"
                type="warning"
                size="sm"
                icon
              >
                <i class="el-icon-guide"></i>
              </base-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="New Action"
              placement="top"
            >
              <base-button
                @click.native="openDlg(props.row)"
                class="edit btn-link"
                type="warning"
                size="sm"
                icon
              >
                <i class="el-icon-circle-plus"></i>
              </base-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="Pemeriksaan Formalitas"
              placement="top"
            >
              <base-button
                @click.native="goToFormChecking(props.row)"
                class="edit btn-link"
                type="warning"
                size="sm"
                icon
              >
                <i class="el-icon-folder-checked"></i>
              </base-button>
            </el-tooltip>
          </div>
        </el-table-column>
      </el-table>
      <div
        slot="footer"
        class="
          col-12
          d-flex
          justify-content-center justify-content-sm-between
          flex-wrap
        "
      >
        <div class="">
          <p class="card-category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
          </p>
        </div>
        <base-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        >
        </base-pagination>
      </div>
    </card>
    <el-dialog
      :title="'New Action'"
      :visible.sync="actionVisible"
      width="43%"
      v-on:opened="initNerf('N')"
    >
      <new-event ref="nerf" :statuscode="''" />
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="saveAction"
          style="padding-right: 20px"
        >
          Save
        </el-button>
        <el-button type="primary" @click="closeDlg">Close</el-button>
      </span>
    </el-dialog>
    <workflow-status v-show="false" ref="Status" />
  </div>
</template>

<script>
import api from "./api";
import apiWorkflow from "../Tables/api";
import {
  Table,
  TableColumn,
  Select,
  Option,
  Loading,
  Card,
  Button,
  Dialog,
} from "element-ui";
import { BasePagination } from "src/components";
import NewEvent from "../Tables/workflow/newAction.vue";
import BaseButton from "../../components/BaseButton.vue";
import WorkflowStatus from "../Tables/workflow/WorkflowStatus.vue";
import StatsCard from "src/components/Cards/StatsCard";
import PatentSearch from "./PatentSearch.vue";
export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Loading.name]: Loading,
    [Card.name]: Card,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    NewEvent,
    BaseButton,
    StatsCard,
    WorkflowStatus,
    PatentSearch,
  },
  data() {
    return {
      statsCards: [
        {
          statusCode: "6000",
          title: "",
          subTitle: "Permohonan Diterima",
          type: "warning",
          icon: "tim-icons icon-email-85",
        },
        {
          statusCode: "6001",
          title: "",
          subTitle: "Pemeriksaan Formalitas",
          type: "primary",
          icon: "tim-icons icon-light-3",
        },
        {
          statusCode: "6003",
          title: "",
          subTitle: "Menunggu Tanggapan Formalitas",
          type: "info",
          icon: "tim-icons icon-notes",
        },
        {
          statusCode: "6004",
          title: "",
          subTitle: "Masa Tenggang Formalitas",
          type: "danger",
          icon: "tim-icons icon-watch-time",
        },
      ],
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      tableColumns: [
        {
          prop: "FILEID",
          label: "File Id",
          minWidth: 100,
        },
        {
          prop: "FILINGDATE",
          label: "Filing Date",
          minWidth: 100,
        },
        {
          prop: "REGNBR",
          label: "Reg Nbr",
          minWidth: 75,
        },
        {
          prop: "APPSUBTYPE",
          label: "App Sub Type",
          minWidth: 150,
        },
        {
          prop: "TITLE",
          label: "Title",
          minWidth: 300,
        },
        {
          prop: "CLASSES",
          label: "Classes",
          minWidth: 100,
        },
        {
          prop: "OWNER",
          label: "Owner",
          minWidth: 200,
        },
        {
          prop: "STATUS",
          label: "Status",
          minWidth: 200,
        },
        {
          prop: "RESPONSIBLE",
          label: "Responsible",
          minWidth: 120,
        },
      ],
      tableData: [],
      searchedData: [],
      total: null,
      actionVisible: false,
      currentAction: {},
      status: {},
      tempData: [],
      statusCode: ["6000", "6001", "6003", "6004"],
    };
  },
  computed: {
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
  },
  async mounted() {
    await this.getPatentList();
  },
  methods: {
    async getPatentList() {
      let loadprg = Loading.service({
        fullscreen: true,
        lock: true,
        text: "Loading ...",
        spinner: "el-icon-loading",
      });
      this.tableData = [];
      const { data } = await api.getPatentList("group=formalitas&isWithPCTID=true");
      const filterData = data.filter((d) => d.STATUSCODE !== "6002");
      this.tableData = filterData;
      this.tempData = filterData;
      this.total = filterData.length;
      for (let index = 0; index < 4; index++) {
        this.statsCards[index].title = `${
          this.tempData.filter((d) => d.STATUSCODE === this.statusCode[index])
            .length
        }`;
      }
      loadprg.close();
    },
    goToDetail(row) {
      this.$router.push(
        `/table-list/patents/${row.FILEID}/edit?classes=${row.CLASSES}&title=${row.APPSUBTYPE}`
      );
    },
    goToWorkflow(row) {
      this.$router.push(`/table-list/patents/workflow/${row.FILEID}`);
    },
    goToFormChecking(row) {
      this.$router.push(`/buat-formalitas/${row.FILEID}`);
    },
    async openDlg(row) {
      await this.getStatusWorkflow(row.FILEID);
      this.actionVisible = true;
    },
    initNerf(state) {
      let statuscode = this.status.STATUS_CODE;
      this.$refs.nerf.init(statuscode, this.status);
      if (state == "N") this.$refs.nerf.action = {};
    },
    async getStatusWorkflow(patentId) {
      try {
        if (patentId.indexOf("ACTION") < 0 && patentId.indexOf("USERDOC") < 0) {
          const { data } = await apiWorkflow.getStatusWorkflow(patentId);
          this.status = data[0];
          this.status.DESC = `File : ${data[0].FILEID} - ${data[0].TITLE} - ${data[0].PERSON}`;
        } else {
          let patentParams = patentId.split("-");
          const procnbr =
            patentParams[5] == "X" ? patentParams[2] : patentParams[5];
          const proctyp =
            patentParams[4] == "X" ? patentParams[1] : patentParams[4];
          const { data } = await apiWorkflow.getStatusSubWorkflow(
            proctyp,
            procnbr
          );
          this.status = data[0];
          this.status.DESC = "";
        }
      } catch (error) {
        console.log(error);
      }
    },
    saveAction() {
      this.$refs.nerf.saveAction();
    },
    closeDlg() {
      this.actionVisible = false;
      this.status = {};
    },
    filterPatent(statusCode) {
      this.tableData = this.tempData;
      this.tableData = this.tableData.filter(
        (data) => data.STATUSCODE === `${statusCode}`
      );
      this.total = this.tableData.length;
    },
    handleData(params) {
      this.tableData = params;
      this.total = params.length;
    },
  },
};
</script>

<style scoped>
.series-number-input {
  width: 140px;
}
</style>
<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
label {
  color: white;
}
</style>
